<template>
  <div id="app">
    <div class="wrapper">
      <router-view/>
    </div>
  </div>
</template>
<script>
import store from './store/index.js'
import { mapGetters } from 'vuex'
import { SAVE_NOTIFICATIONS } from './store/keys'

export default {
  name: 'app',
  data() {
    return {
      timer: null,
      isCloseNotificationsSocket: false,
      notificationsSocket: null
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'notifications'
    ])
  },
  methods: {
    keepSessionActive() {
      this.timer = setInterval(() => {
        if (this.currentUser) {
          this.getUserData()
        }
      }, 1000 * 300)
    },
    getUserData() {
      const apiBaseUrl = process.env.VUE_APP_API_URL
      const params = {
        Call: 'Accountdetail',
        MerchantID: this.currentUser.ID,
        APIKey: this.currentUser.APIKey,
        output: 'json'
      }
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: params,
        withCredentials: true
      }).then(response => {}).catch(() => {})
    },
    initNotificationsSocket() {
      this.notificationsSocket = new WebSocket('wss://wss.cointopay.com/balance')
      const self = this
      this.notificationsSocket.onmessage = (event) => {
        if (event) {
          if (event.data) {
            const parts = event.data.split(':')
            if (parts.length === 4) {
              const notifications = self.notifications
              const notification = self.generateNotification(parts)
              notifications.splice(0, 0, notification)
              self.$store.commit(SAVE_NOTIFICATIONS, notifications)
            }
          }
        }
      }
      this.notificationsSocket.onclose = (event) => {
        if (!self.isCloseNotificationsSocket) {
          self.initNotificationsSocket()
        }
      }
    },
    generateNotification(parts) {
      let message = ''
      let prefix = 'T'
      const id = prefix + parts[1].padStart(9, '0')
      switch (parts[2]) {
        case 'PAID':
          prefix = 'T'
          message = `${id} paid successfully`
          break
        case 'EXPIRED':
          prefix = 'T'
          message = `${id} has expired`
          break
        case 'PAYOUT':
          prefix = 'P'
          message = `${id} payout successful`
      }
      return {
        message: message,
        id: id,
        date: new Date()
      }
    }
  },
  created() {
    this.keepSessionActive()
    this.initNotificationsSocket()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.notificationsSocket) {
      this.isCloseNotificationsSocket = true
      this.notificationsSocket.close()
    }
  },
  store
}
</script>
<style lang="scss">
  @import '~sweetalert2/src/sweetalert2';
  @import '~@sweetalert2/theme-bootstrap-4/bootstrap-4';
  @import "~vue-select/src/scss/vue-select";
  @import "~bootstrap-select/sass/bootstrap-select";
  @import './assets/scss/styles';
  .swal2-popup { font-size: 1.6rem !important; }
  .table {
    thead {
      tr {
        th {
          border-top: 2px solid #f4f4f4 !important;
        }
      }
    }
  }
  a {
    cursor: pointer;
  }
  .wrapper {
    min-width: 1280px !important;
  }
</style>
